import httpClient from "../../../shared/api/httpClient";

export const relatoriosApi = {
  gerar: ({ vinculoId, ano, mes }) =>
    httpClient.post(`/api/v1/vinculos/${vinculoId}/comprovacoes`, { ano, mes }).then((r) => r.data.dados),

  listar: () => httpClient.get("/api/v1/comprovacoes").then((r) => r.data.dados),

  obterDocumento: (id) => httpClient.get(`/api/v1/comprovacoes/${id}`).then((r) => r.data.dados),

  // Baixa o PDF como blob e dispara o download no navegador.
  baixarPDF: async (id) => {
    const response = await httpClient.get(`/api/v1/comprovacoes/${id}/pdf`, { responseType: "blob" });
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = `comprovacao-${id}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  enviar: ({ id, destinatario }) =>
    httpClient.post(`/api/v1/comprovacoes/${id}/enviar`, { destinatario: destinatario || "" }).then((r) => r.data),
};
